import WorkerState from '../../../../../shared/model/WorkerState';

export class PresenceWorkerSearchRequest {

    _term; // string
    _companyId; // number

    constructor(companyId) {
        this._term = '';
        this._companyId = companyId;
    }

    setTerm(term) {
        this._term = term;
    }

    body() {
        return {
            criteria: {
                skip_pagination: true,
                term: this._term,
                company_id: this._companyId,
                worker_state_ids: [WorkerState.ACTIVE],
                show_only_deleted: false,
                include_only_company_workers: true,
                include_only_contractor_workers: false,
                retrieve_worker_documentation_state: true,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/webservices/presence-worker-search/PresenceWorkerSearchRequest.js